var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCurrencyTablets = function SvgCurrencyTablets(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_862_130905)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    transform: "translate(0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.7435,
    cy: 34.8158,
    rx: 26.5952,
    ry: 31.4615,
    transform: "rotate(-9.11532 31.7435 34.8158)",
    fill: "url(#paint0_linear_862_130905)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.6545,
    cy: 34.1886,
    rx: 26.0293,
    ry: 31.4615,
    transform: "rotate(-9.11532 35.6545 34.1886)",
    fill: "url(#paint1_linear_862_130905)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 21.7734,
    ry: 26.3174,
    transform: "matrix(-0.987372 0.158422 0.158422 0.987372 35.6542 34.1883)",
    fill: "url(#paint2_linear_862_130905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9984 45.1177C38.5218 45.4687 37.1231 45.4634 35.8021 45.1017C34.4811 44.74 33.2916 44.02 32.2336 42.9418C31.1961 41.8587 30.3307 40.4513 29.6373 38.7197L30.268 39.3218L27.8071 39.9069C27.4995 39.98 27.2083 39.9402 26.9337 39.7875C26.6542 39.6142 26.4751 39.3625 26.3967 39.0323C26.3182 38.7022 26.3672 38.4072 26.5437 38.1472C26.7202 37.8872 26.9623 37.7207 27.2699 37.6476L29.6078 37.0918L29.2862 37.7895C29.0775 37.1851 28.8971 36.5631 28.745 35.9235C28.6086 35.2584 28.4946 34.6424 28.4032 34.0756L29.0352 34.5466L26.6666 35.1097C26.359 35.1829 26.0678 35.1431 25.7932 34.9904C25.5137 34.8171 25.3371 34.5756 25.2635 34.2661C25.185 33.936 25.234 33.641 25.4106 33.381C25.5822 33.1004 25.8218 32.9236 26.1294 32.8504L28.7441 32.2288L28.3055 33.1178C28.1404 31.2388 28.2799 29.5925 28.7238 28.179C29.1834 26.74 29.9216 25.5617 30.9384 24.6442C31.9553 23.7267 33.202 23.0924 34.6785 22.7414C35.7039 22.4976 36.7275 22.4286 37.7493 22.5345C38.7662 22.6197 39.7424 22.9435 40.6777 23.5059C40.9778 23.6743 41.1905 23.8854 41.3158 24.139C41.441 24.3926 41.4946 24.6632 41.4763 24.951C41.4531 25.2181 41.3664 25.4458 41.2162 25.6341C41.066 25.8224 40.8576 25.9482 40.591 26.0116C40.3244 26.075 40.0181 26.017 39.6721 25.8377C39.0515 25.5056 38.3886 25.3145 37.6833 25.2642C36.978 25.2139 36.2665 25.274 35.5487 25.4447C34.6464 25.6592 33.8727 26.0502 33.2276 26.6178C32.5825 27.1853 32.112 27.9402 31.8161 28.8826C31.5406 29.82 31.4372 30.9346 31.506 32.2262L30.8051 31.7388L35.4193 30.6418C35.7474 30.5638 36.041 30.6139 36.3 30.7921C36.5796 30.9654 36.7561 31.2068 36.8297 31.5163C36.9033 31.8258 36.8543 32.1209 36.6826 32.4015C36.5266 32.6565 36.2846 32.8231 35.9564 32.9011L31.1269 34.0493L31.6097 33.3459C31.6659 33.8558 31.7725 34.4408 31.9295 35.101C32.0865 35.7613 32.2644 36.373 32.4632 36.9361L31.7303 36.5871L36.5598 35.4389C36.8879 35.3609 37.1815 35.411 37.4405 35.5892C37.7152 35.7419 37.8893 35.973 37.9628 36.2825C38.0364 36.592 37.9874 36.8871 37.8158 37.1676C37.6647 37.4434 37.4251 37.6202 37.0969 37.6982L32.6366 38.7587L32.8893 38.0446C33.4092 39.2289 34.0056 40.188 34.6783 40.9218C35.3667 41.6301 36.1267 42.0925 36.9581 42.309C37.7896 42.5255 38.6565 42.5265 39.5588 42.312C40.2971 42.1365 40.9518 41.8827 41.5228 41.5508C42.089 41.1982 42.613 40.7139 43.0949 40.098C43.3486 39.7979 43.5985 39.6186 43.8446 39.5601C44.1062 39.4761 44.349 39.4946 44.5728 39.6158C44.7917 39.7164 44.9614 39.8831 45.0817 40.1161C45.2177 40.3236 45.2868 40.5687 45.2891 40.8516C45.3069 41.1089 45.2198 41.3803 45.0277 41.6658C44.507 42.5743 43.7962 43.321 42.8952 43.9058C41.9894 44.4699 41.0237 44.8739 39.9984 45.1177Z",
    fill: "#90CAF9"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.2808,
    cy: 54.012,
    rx: 26.5952,
    ry: 31.4615,
    transform: "rotate(12.5145 63.2808 54.012)",
    fill: "url(#paint3_linear_862_130905)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.1473,
    cy: 54.8698,
    rx: 26.0293,
    ry: 31.4615,
    transform: "rotate(12.5145 67.1473 54.8698)",
    fill: "url(#paint4_linear_862_130905)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 21.7734,
    ry: 26.3174,
    transform: "matrix(-0.976241 -0.216686 -0.216686 0.976241 67.1478 54.8706)",
    fill: "url(#paint5_linear_862_130905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.828 66.1965L61.1749 64.693C58.1346 63.7107 56.4956 60.3557 57.5139 57.2042C57.7595 56.4442 58.5934 56.0175 59.3535 56.2631C60.1136 56.5087 60.5402 57.3426 60.2946 58.1027C59.7735 59.7156 60.5718 61.4271 62.0734 61.9123L66.7265 63.4158C67.9315 63.8051 69.2799 63.0534 69.6992 61.7557C70.2204 60.1428 69.7475 59.642 68.9099 59.0028L62.2895 53.9564C61.0053 52.9887 59.4061 51.2845 60.4783 47.9662C61.4008 45.1113 64.3867 43.5373 67.1304 44.4238L71.7835 45.9273C74.8238 46.9096 76.4627 50.2646 75.4445 53.4161C75.1989 54.1762 74.3649 54.6028 73.6048 54.3572C72.8448 54.1116 72.4181 53.2777 72.6637 52.5176C73.1848 50.9048 72.3866 49.1932 70.885 48.708L66.2319 47.2045C65.0269 46.8152 63.6784 47.567 63.2591 48.8646C62.738 50.4775 63.2108 50.9783 64.0485 51.6175L70.6688 56.6639C71.9531 57.6316 73.5522 59.3358 72.48 62.6542C71.545 65.4845 68.5716 67.083 65.828 66.1965Z",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4358 67.8236C61.6757 67.578 61.2491 66.7441 61.4946 65.984L68.6826 43.738C68.9282 42.978 69.7621 42.5513 70.5222 42.7969C71.2823 43.0425 71.7089 43.8765 71.4633 44.6365L64.2754 66.8825C64.0298 67.6426 63.1958 68.0692 62.4358 67.8236Z",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5,
    cy: 92,
    rx: 39,
    ry: 2,
    fill: "url(#paint6_linear_862_130905)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_130905",
    x1: 5.14834,
    y1: 33.1224,
    x2: 41.0338,
    y2: 10.4543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ECCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_862_130905",
    x1: 9.62521,
    y1: 32.4952,
    x2: 53.5256,
    y2: 40.5963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_862_130905",
    x1: -19.6882,
    y1: 18.8618,
    x2: 42.6505,
    y2: 20.6239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560479,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_862_130905",
    x1: 36.6856,
    y1: 52.3186,
    x2: 72.5711,
    y2: 29.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ECCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_862_130905",
    x1: 41.118,
    y1: 53.1765,
    x2: 85.0184,
    y2: 61.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_862_130905",
    x1: -19.6882,
    y1: 18.8618,
    x2: 42.6505,
    y2: 20.6239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "#C0E1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560479,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_862_130905",
    x1: 8.8,
    y1: 92.8,
    x2: 80.2613,
    y2: 90.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEFF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_862_130905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCurrencyTablets);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "currency-tablets.c5a3bc8ffa9fa80a797b631dc2c7fa13.svg";